import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { IconButton } from 'react-toolbox/lib/button'
import CSSModules from 'helpers/CSSModulesUtil'
import {
  withState,
  withHandlers,
  pure,
  compose,
  branch,
  renderComponent
} from 'recompose'

const ModifyIconButton = ({ onClick }) => {
  return (
    <IconButton
      onClick={onClick}
      icon='edit'
    />
  )
}

const SaveModificationButton = ({ onClick, onDoneIcon = 'save' }) => {
  return (
    <IconButton
      onClick={onClick}
      icon={onDoneIcon}
    />
  )
}

const withEditHandlers = compose(
  withState('edit', 'toggleEdit', false),
  withHandlers({
    toggleEdit: ({ toggleEdit }) => (value) => toggleEdit(e => value)
  })
)

const EditIconButton = compose(
  branch(
    ({ edit }) => edit,
    renderComponent(SaveModificationButton)
  ),
  pure,
)(ModifyIconButton)

export {
  EditIconButton,
  withEditHandlers
}
